import * as React from "react";

function SvgStartAll(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 32" fill="none" {...props}>
      <path d="M.917.417L23.583 16 .917 31.583V.417z" fill="#fff" />
    </svg>
  );
}

export default SvgStartAll;
